<template>
  <div class="personnel">
    <FORM ref="childForm" @formclick="formClick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
import FORM from '@/components/page/form.vue'
import tablePage from '@/components/page/table'
import UPDATE from '@/components/page/update'
import Url from '@/views/proxy/util/url'
import DateUtil from '@/utils/IM/tradeDataUtil'
import Qs from 'qs'

let statusArr = { 1: '启用', 2: '禁用', 0: '待審批' }
let settingIdArr = {}
export default {
  name: 'proxyConfig',
  components: {
    FORM,
    tablePage,
    UPDATE
  },

  data() {
    return {
      groupId: DateUtil.getParamKey(this.$route.params),
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '代理Code', field: 'code' },
          { title: '代理名称', field: 'agentName' },
          { title: '關聯賬號', field: 'customerNumber' },
          { title: '手機號', field: 'phone' },
          {
            title: window.$t('crs.quantityTask.type'),
            field: 'status',
            type: 2,
            optionList: statusArr,
            data: []
          },
          {
            title: '时间',
            field: 'time',
            type: 6,
            format: 'yyyy-MM-dd HH:mm:ss',
            startEndParam: ['startTime', 'endTime']
          },
          { click: window.$t('common.search') }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: Url.adAgent.settingPersonnels + '?groupId=' + DateUtil.getParamKey(this.$route.params),
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          { title: 'uniKey', field: 'uniKey', hidden: true },
          { title: '代理编码', field: 'code' },
          { title: '代理名称', field: 'agentName' },
          { title: '關聯賬號', field: 'customerNumber' },
          { title: '手機號', field: 'phone' },
          { title: '交易返佣方案ID', field: 'settingId' },
          { title: '交易返佣方案', field: 'settingName' },
          { title: '创建人', field: 'cname' },
          {
            title: '创建时间', field: 'ctime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '代理状态', field: 'status', render: (data, full) => {
              return statusArr[data]
            }
          },
          { title: '审批人', field: 'uname' },
          {
            title: '审批时间', field: 'updateTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: 'groupId', field: 'groupId' },
          {
            title: window.$t('common.operation'),
            btnClick: [
              {
                name: '方案配置',
                click: 'update',
                type: 'primary',
                icon: 'el-icon-edit',
                auth: 'proxy:setting:edit'
              },
              {
                name: window.$t('common.approve'),
                click: 'approve',
                type: 'primary',
                icon: 'el-icon-approve',
                auth: 'proxy:setting:approve', hidden: (data, full) => {
                  return full.status == 1
                }
              },
              {
                name: window.$t('common.reject'),
                click: 'reject',
                type: 'primary',
                icon: 'el-icon-reject',
                auth: 'proxy:setting:reject', hidden: (data, full) => {
                  return full.status == 2
                }
              }
            ]
          }
        ]
      },
      /*新增或更新*/
      updateData: {
        cols: [
          { title: '代理编码', field: 'code', data: '', disable: true, readonly: true },
          { title: '代理名称', field: 'agentName', data: '', required: true, disable: true },
          {
            title: '交易返佣方案',
            field: 'settingId',
            type: 2,
            optionList: {},
            required: true,
            isNumber: true
          }
        ]
      },
      pCodeListL: []
    }
  },
  methods: {
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    /*查询表单按钮点击事件*/
    formClick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        data.startTime = data.startTime ? new Date(data.startTime).getTime() : ''
        data.endTime = data.endTime ? new Date(data.endTime).getTime() : ''
        this.queryData = data
        this.$refs.childTable.defaultGetData(data)
      }
    },

    rebateSetListAll() {
      this.$axios.get(Url.adAgent.rebateSetListAll + '?groupId=' + this.groupId).then(res => {
        if (res.code == 0) {
          let arr = {}
          if (res.result) {
            let data = res.result
            for (const i in data) {
              arr[data[i].id] = data[i].name
            }
          }
          settingIdArr = arr
          this.updateData.cols.find(function(e) {
            return e.field == 'settingId'
          }).optionList = arr
        }
      })
    },
    /*表格按钮点击事件*/
    bthClick(clickName, row) {
      if (clickName == 'update') {
        this.$refs.childUpdate.open(row)
      } else if (clickName == 'reject' || clickName == 'approve') {
        row.status = clickName == 'approve' ? 1 : 2
        this.dataChange(Url.adAgent.settingStatus, row, res => {
          if (res.code == 0) {
            this.$refs.childUpdate.close()
            this.$message.success('操作成功')
            this.$refs.childTable.defaultGetData(this.queryData)
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    /*新增或跟提交数据触发事件*/
    submit(model) {
      model.groupId = this.groupId
      this.dataChange(Url.adAgent.settingEdit, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultGetData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    }
  },
  mounted() {
    this.rebateSetListAll()
  }
}
</script>
